import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=7d8dfbc7&scoped=true"
import script from "./ViewForm.vue?vue&type=script&lang=js"
export * from "./ViewForm.vue?vue&type=script&lang=js"
import style0 from "./ViewForm.vue?vue&type=style&index=0&id=7d8dfbc7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8dfbc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d8dfbc7')) {
      api.createRecord('7d8dfbc7', component.options)
    } else {
      api.reload('7d8dfbc7', component.options)
    }
    module.hot.accept("./ViewForm.vue?vue&type=template&id=7d8dfbc7&scoped=true", function () {
      api.rerender('7d8dfbc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/audit/sku/componentsCSG/ViewForm.vue"
export default component.exports